export default "__VITE_ASSET__BsnSxYyh__"